<div class="reply-context" [class.reply-context--self]="isSelf">
  <div class="reply-context__body">
    <span class="reply-context__sender">{{ senderLabel }}</span>
    <div class="reply-context__text">
      <app-message-renderer [message]="replyMessage!" [showInfo]="false" [showAiInsights]="false"/>
    </div>
  </div>
  <button class="reply-context__clear" (click)="onClear()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>
